<script setup lang="ts">
  import { useTranslation } from '@/composables/useTranslation'
  import { computed, inject, unref, type ComputedRef, type Ref } from 'vue'

  const { t } = useTranslation({
    en: {
      teamVisibility: 'Conversations are visible to colleagues',
      aiAndTeamVisibility:
        'JUPUS is an AI and can make mistakes. Please verify answers. Conversations are visible to colleagues.'
    },
    de: {
      teamVisibility: 'Konversationen sind für Kollegen sichtbar',
      aiAndTeamVisibility:
        'JUPUS ist eine KI und kann Fehler machen. Bitte überprüfen Sie die Antworten. Konversationen sind für Kollegen sichtbar.'
    },
    fr: {
      teamVisibility: 'Les conversations sont visibles par vos collègues',
      aiAndTeamVisibility:
        'JUPUS est une IA et peut faire des erreurs. Veuillez vérifier les réponses. Les conversations sont visibles par vos collègues.'
    }
  })

  const centerAiAssistantComposer = inject<Ref<boolean> | ComputedRef<boolean>>(
    'centerAiAssistantComposer',
    computed(() => true)
  )

  const disclaimerClass = computed(() =>
    unref(centerAiAssistantComposer)
      ? 'mx-auto w-full max-w-5xl px-0 pb-0 text-center text-xs leading-4 text-gray-500 dark:text-neutral-500'
      : 'mx-auto max-w-4xl px-4 pb-3 text-center text-xs leading-4 text-gray-500 dark:text-neutral-500'
  )

  const disclaimerText = computed(() =>
    unref(centerAiAssistantComposer) ? t('teamVisibility') : t('aiAndTeamVisibility')
  )
</script>

<template>
  <p
    :class="disclaimerClass"
    data-cy="team-disclaimer"
  >
    {{ disclaimerText }}
  </p>
</template>
